import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureFromLocation } from "@/lib/attribution";

/**
 * Captures UTM parameters + referrer + landing path into localStorage on
 * every route change so that downstream form submits include attribution.
 *
 * Mounted inside <BrowserRouter> in App.js. Renders nothing.
 */
export default function AttributionListener() {
  const location = useLocation();

  useEffect(() => {
    captureFromLocation();
  }, [location.pathname, location.search]);

  return null;
}
